var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    viewBox: "0 0 49 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 36,
    rx: 18,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 36,
    rx: 18,
    stroke: "#13499F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1291 21.2393C18.0187 20.1467 17.3679 18.9773 17.1291 18.5004C17.3679 18.0235 18.0187 16.8541 19.1291 15.7615C20.3555 14.5549 22.1175 13.464 24.5 13.464C26.8825 13.464 28.6445 14.5549 29.8709 15.7615C30.9813 16.8541 31.6321 18.0235 31.871 18.5004C31.6321 18.9773 30.9813 20.1467 29.8709 21.2393C28.6445 22.446 26.8825 23.5368 24.5 23.5368C22.1175 23.5368 20.3555 22.446 19.1291 21.2393ZM24.5 12.3701C21.7496 12.3701 19.7269 13.6387 18.3619 14.9818C17.0022 16.3196 16.2703 17.7532 16.0764 18.1636C15.9745 18.3792 15.9745 18.6216 16.0764 18.8372C16.2703 19.2476 17.0022 20.6812 18.3619 22.0191C19.7269 23.3622 21.7496 24.6307 24.5 24.6307C27.2504 24.6307 29.2731 23.3622 30.6381 22.0191C31.9978 20.6812 32.7297 19.2476 32.9236 18.8372C33.0255 18.6216 33.0255 18.3792 32.9236 18.1636C32.7297 17.7532 31.9978 16.3196 30.6381 14.9818C29.2731 13.6387 27.2504 12.3701 24.5 12.3701ZM22.6541 18.5004C22.6541 17.4809 23.4805 16.6545 24.5 16.6545C25.5195 16.6545 26.3459 17.4809 26.3459 18.5004C26.3459 19.5199 25.5195 20.3463 24.5 20.3463C23.4805 20.3463 22.6541 19.5199 22.6541 18.5004ZM24.5 15.5606C22.8764 15.5606 21.5602 16.8768 21.5602 18.5004C21.5602 20.124 22.8764 21.4402 24.5 21.4402C26.1236 21.4402 27.4398 20.124 27.4398 18.5004C27.4398 16.8768 26.1236 15.5606 24.5 15.5606Z",
    fill: "#13499F",
    stroke: "#13499F",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.0ce36a48265ddd27ba6355f22a2f306b.svg";
export { ForwardRef as ReactComponent };